module.exports = __webpack_public_path__ + "static/bayer-logo-5ab734302d8d3820b7902726d3fa6d1f.png";